import { useState } from 'react'
import { Alert, Snackbar, Typography } from '@mui/material'

export default function CopyToClipboard({ text }: { text: string }) {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
    } catch (err) {
      console.error('Erreur de copie', err)
    }
  }

  return (
    <>
      {/* Ton interface */}
      <Typography
        component="span"
        onClick={() => copyToClipboard(text)}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {text}
      </Typography>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setCopied(false)} severity="success" variant="filled">
          Copié dans le presse-papiers !
        </Alert>
      </Snackbar>
    </>
  )
}
